import { useTranslation } from 'react-i18next';
import SectionHeader from '../../../components/SectionHeader';
import SwitchActivation from '../../../components/layout/SwitchActivation';
import { FieldArray, getIn, useFormikContext } from 'formik';
import useSectionModelsData from '../../../hooks/useSectionModelsData';
import FieldWrapper from '../../../components/formInputs/FieldWrapper';
import { customStyles } from '../../../utils/SelectStyles';
import { deleteIcon, plusIcon } from '../../../config/variables';
import Button from '../../../components/buttons/Button';
import ModelDataSkeleton from '../../../components/loaders/ModelDataSkeleton';
import { Fragment } from 'react/jsx-runtime';

export default function PageSectionModels({ subSection, sectionName, hasRelation }: { subSection?: boolean; sectionName: string; hasRelation: boolean }) {
  const { t } = useTranslation();
  const formik = useFormikContext();

  const sectionData = getIn(formik.values, `${sectionName}`);

  const { selectOptions, dataTypesOptions, isLoading } = useSectionModelsData(sectionData?.model_type);

  return (
    <SectionHeader title={t('extra_data')}>
      <div className="inputs_group" style={{ marginBottom: '2rem' }}>
        <div className="switch_container">
          <SwitchActivation
            onChange={(value: any) => {
              formik.setFieldValue(`${sectionName}.has_relation`, value?.target?.checked ? 1 : 0);
              if (!sectionData?.model_data?.length) {
                formik.setFieldValue(`${sectionName}.model_data`, [{}]);
              }
            }}
            active={sectionData?.has_relation === 1}
          />
          <p>{t('has_data')}</p>
        </div>
      </div>
      {!!hasRelation && (
        <div>
          <div className="inputs_group">
            <FieldWrapper
              customPadding
              title={t('model_type')}
              inputPlaceholder={t(`model_type`)}
              inputName={`${sectionName}.model_type`}
              options={dataTypesOptions}
              selectStyle={customStyles}
              defaultValue={dataTypesOptions?.find((item: any) => item.value === sectionData?.model_type)}
              select
              formik={formik}
            />
          </div>
          <FieldArray
            name={`${sectionName}.model_data`}
            render={(arrayHelpers) => {
              return (
                <div>
                  {isLoading ? (
                    <ModelDataSkeleton />
                  ) : (
                    <Fragment>
                      {sectionData?.model_data?.map((modelItem: any, index: number) => (
                        <div className="pointer" style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                          <div className="inputs_group">
                            <FieldWrapper
                              customPadding
                              title={t('model_data')}
                              inputPlaceholder={t(`model_data`)}
                              inputName={`${sectionName}.model_data[${index}].model_id`}
                              options={selectOptions}
                              selectStyle={customStyles}
                              defaultValue={selectOptions?.find((item: any) => item.value === modelItem.model_id)}
                              select
                              formik={formik}
                            />
                            <FieldWrapper title={t('order')} inputName={`${sectionName}.model_data[${index}].order`} inputPlaceholder={t('order')} input />
                          </div>
                          <span
                            onClick={() => {
                              arrayHelpers.remove(index);
                            }}
                            style={{ paddingBottom: '0.7rem' }}
                          >
                            {deleteIcon}
                          </span>
                        </div>
                      ))}
                      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '2rem' }}>
                        <Button
                          onClick={() => {
                            arrayHelpers.push({});
                          }}
                        >
                          <div className="add-section_btn_content">
                            {plusIcon} {t('add_new_data_model')}
                          </div>
                        </Button>
                      </div>
                    </Fragment>
                  )}
                </div>
              );
            }}
          />
        </div>
      )}
    </SectionHeader>
  );
}
